const organization = {
    require_membership: "L'utilisateur doit être membre de l'organisation pour continuer.",
};
export default Object.freeze(organization);
